export default __webpack_public_path__ + "static/media/flayer99.bfd36fb4.jpg";